import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@sainsburys-tech/bolt';
import { useVocab } from '@sainsburys-tech/bolt-vocab-provider';

var getErrorMessages = function getErrorMessages(errorCode, ITEM_CONTAINER) {
  var errorMessages = {
    GENERIC_ERROR: 'Sorry, but something went wrong when adding this item. Please try again.',
    INVALID_PRODUCT: "Sorry, but this item's no longer available.",
    EXCEEDS_MAX_ALLOWED_QUANTITY: "Sorry, but you can't add any more of this particular item to your ".concat(ITEM_CONTAINER, "."),
    EXCEEDS_MAX_ALLOWED_ITEMS: "Sorry, but you've reached the maximum amount of items in your ".concat(ITEM_CONTAINER, ".")
  };
  return errorMessages[errorCode] || errorMessages.GENERIC_ERROR;
};

var ModalFailedState = function ModalFailedState(_ref) {
  var errorCode = _ref.errorCode;

  var _useVocab = useVocab(),
      ITEM_CONTAINER = _useVocab.ITEM_CONTAINER;

  return /*#__PURE__*/React.createElement(Alert, {
    kind: "error",
    isCloseable: false
  }, getErrorMessages(errorCode, ITEM_CONTAINER));
};

ModalFailedState.propTypes = {
  errorCode: PropTypes.string
};
export default ModalFailedState;